import type { DemoScene } from "./demoScenario";

export type DemoFeature = "voice-guidance" | "nutrient-status" | "menu-guidance" | "fridge-guidance";
export const FRIDGE_PHOTO = "/images/nomsy-feature-fridge.png";

// Short, independent stories. Scene clocks also drive highlights and reveals.
export const FEATURE_TOURS: Record<DemoFeature, {
  label: string;
  description: string;
  duration: number;
  stillTime: number;
  scenes: readonly DemoScene[];
}> = {
  "voice-guidance": {
    label: "Nomsy voice logging animation",
    description: "Say: I had two eggs and a slice of toast. Review and log the meal. Tap Change anything and say: Actually, three eggs, and add butter to the toast. The saved meal updates to three eggs, toast, and butter.",
    duration: 20000,
    stillTime: 17500,
    scenes: [
      { id: "voice-capture", start: 0, end: 6000, screen: "voice-log", target: "send", caption: "", chapter: 0 },
      { id: "voice-saved", start: 6000, end: 10000, screen: "voice-entry", target: "voice-change", caption: "", chapter: 0 },
      { id: "voice-correction", start: 10000, end: 15500, screen: "voice-edit", target: "send", caption: "", chapter: 0 },
      { id: "voice-updated", start: 15500, end: 20000, screen: "voice-entry", complete: true, caption: "", chapter: 0 },
    ],
  },
  "nutrient-status": {
    label: "Nomsy nutrient status animation",
    description: "Switch between On Target, Too Low, and Too High to see your nutrient amounts and personal ranges. Animated bars show where each amount falls.",
    duration: 15000,
    stillTime: 0,
    scenes: [
      { id: "target-ranges", start: 0, end: 5000, screen: "nutrient-status", nutrientStatus: "good", target: "filter-low", caption: "", chapter: 0 },
      { id: "low-ranges", start: 5000, end: 10000, screen: "nutrient-status", nutrientStatus: "low", target: "filter-high", caption: "", chapter: 0 },
      { id: "high-ranges", start: 10000, end: 15000, screen: "nutrient-status", nutrientStatus: "high", target: "filter-good", caption: "", chapter: 0 },
    ],
  },
  "menu-guidance": {
    label: "Nomsy restaurant menu animation",
    description: "Photograph a restaurant menu. Nomsy suggests the grilled salmon for your protein needs. Open the recommendation to see how to customize your order: extra vegetables and sauce on the side.",
    duration: 15000,
    stillTime: 9000,
    scenes: [
      { id: "menu-camera", start: 0, end: 3000, screen: "camera", restaurant: true, target: "shutter", caption: "", chapter: 0 },
      { id: "menu-analysis", start: 3000, end: 5000, screen: "menu-analysis", restaurant: true, caption: "", chapter: 0 },
      { id: "menu-choices", start: 5000, end: 8500, screen: "menu-result", target: "menu-choice", caption: "", chapter: 0 },
      { id: "menu-customize", start: 8500, end: 15000, screen: "menu-result", complete: true, caption: "", chapter: 0 },
    ],
  },
  "fridge-guidance": {
    label: "Nomsy fridge guidance animation",
    description: "Photograph your fridge. Nomsy analyzes the available food and reveals which foods can help close your current nutrient gaps, including an egg recommendation for protein.",
    duration: 15000,
    stillTime: 6000,
    scenes: [
      { id: "fridge-camera", start: 0, end: 3000, screen: "camera", fridge: true, target: "shutter", caption: "", chapter: 0 },
      { id: "fridge-analysis", start: 3000, end: 5000, screen: "fridge-analysis", fridge: true, caption: "", chapter: 0 },
      { id: "fridge-guidance", start: 5000, end: 15000, screen: "fridge-result", fridge: true, caption: "", chapter: 0 },
    ],
  },
};
